module.exports = __webpack_public_path__ + "img/responsive-wood.5fd25cdc.png";